import { parse, stringify } from "query-string";
import { useHistory } from "react-router-dom";
import { PaymentModalStates } from "../../utils/constants";
import { USER_ROUTES } from "../../utils/routeConstants";
import { Container, MainButton } from "./ContadoConfirmationStyles";

function ContadoConfirmation(props) {
  const { toggleModal, paymentState, dataCode, closeModal, redirectRecaudo } =
    props;
  const history = useHistory();

  const paymentMethod = (payment) => {
    switch (payment) {
      case PaymentModalStates.BCP:
      case PaymentModalStates.BBVA:
        return (
          <Container>
            {!dataCode ? (
              <h1>Pago pendiente de validación</h1>
            ) : (
              <h1>Pago confirmado con éxito</h1>
            )}
            {!dataCode ? (
              <p>
                Su pago ha sido generado, nuestro equipo de facturación se
                encuentra validándolo.
              </p>
            ) : (
              <p>
                Su pago ha sido confirmado exitosamente, su código de pago es:
              </p>
            )}
            {dataCode && (
              <p style={{ marginTop: "-1rem", color: "#2E353D" }}>
                <b> {dataCode.upfront_payment_detail.bank_payment_code}</b>
              </p>
            )}
            <MainButton
              onClick={() => {
                const parsedParams = {
                  ...parse(window.location.search),
                  page: 1,
                };
                const stringifiedParams = stringify(parsedParams);
                const pathname = history.location.pathname;
                closeModal();
                if (redirectRecaudo > 0) {
                  history.push(`${pathname}?${stringifiedParams}`);
                } else {
                  history.push(USER_ROUTES.PAYMENT_VALIDATION_STATUS.path);
                }
              }}
            >
              Entendido
            </MainButton>
          </Container>
        );
      default:
        return (
          <Container>
            <h1>Pago pendiente de validación</h1>
            <p>
              Su pago ha sido generado, nuestro equipo de facturación se
              encuentra validándolo.
            </p>
            <MainButton onClick={() => toggleModal(true)}>Entendido</MainButton>
          </Container>
        );
    }
  };
  return paymentMethod(paymentState);
}

export default ContadoConfirmation;
